import { Component, input, output } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-listing-details-cta-villages-desktop',
  styleUrl: './desktop.css',
  templateUrl: './desktop.html',
})
export class ListingDetailsCtaVillagesDesktop {
  public readonly footnote = input.required<string>();
  public readonly image = input.required<string>();
  public readonly lppClicked = output();
  public readonly price = input.required<number>();
}
